// antd
import { Image, Row, Space, theme, Typography } from 'antd'
import { CertificateIcon, CertificatesLogoIcon } from '../../../assets/icons'
import { fileTypes, videoTypes } from '../../../constants/mediaTypes'
import ModalProfile from '../../../components/modal'
import ViewMultiMediaModal from '../modals/viewMultimediaModal'
import { useState } from 'react'

// styles
import tabStyles from '../profileTabContent.module.css'

function CertificatesSummaryContent({ contentData }) {
    const { Title, Text } = Typography

    const { useToken } = theme
    const { token } = useToken()

    const [viewMediaCertificate, setViewMediaCertificate] = useState({
        open: false,
        file: {},
    })

    return (
        <>
            <div className={tabStyles.summaryList}>
                {contentData?.length > 0 &&
                    contentData.map((certificateData, index) => {
                        const startDate =
                            certificateData?.dateReceived !== null
                                ? new Date(certificateData?.dateReceived)
                                : null
                        return (
                            <div
                                className={tabStyles.summaryItem}
                                key={
                                    certificateData?._id ||
                                    certificateData?.title ||
                                    index
                                }
                            >
                                <div className={tabStyles.itemMain}>
                                    {certificateData?.fileLink?.length > 0 ? (
                                        fileTypes.some((r) =>
                                            certificateData?.fileLink[0]
                                                ?.toLowerCase()
                                                .includes(r)
                                        ) ? (
                                            <div className={tabStyles.logoBox}>
                                                <Image
                                                    src={
                                                        certificateData
                                                            ?.fileLink[0]
                                                    }
                                                    preview={false}
                                                    style={{
                                                        cursor: 'pointer',
                                                    }}
                                                    onClick={() => {
                                                        setViewMediaCertificate(
                                                            {
                                                                open: true,
                                                                file: {
                                                                    name: certificateData?.title,
                                                                    description:
                                                                        certificateData?.description,
                                                                    files: certificateData?.fileLink,
                                                                },
                                                            }
                                                        )
                                                    }}
                                                />
                                            </div>
                                        ) : videoTypes.some((r) =>
                                              certificateData?.fileLink[0].includes(
                                                  r
                                              )
                                          ) ? (
                                            <div className={tabStyles.logoBox}>
                                                <video
                                                    src={
                                                        certificateData
                                                            ?.fileLink[0]
                                                    }
                                                    style={{
                                                        width: '100%',
                                                        height: '100%',
                                                        objectFit: 'cover',
                                                        cursor: 'pointer',
                                                    }}
                                                    onClick={() => {
                                                        setViewMediaCertificate(
                                                            {
                                                                open: true,
                                                                file: {
                                                                    name: certificateData?.title,
                                                                    description:
                                                                        certificateData?.description,
                                                                    files: certificateData?.fileLink,
                                                                },
                                                            }
                                                        )
                                                    }}
                                                />
                                            </div>
                                        ) : (
                                            <div
                                                className={tabStyles.logoBox}
                                                onClick={() => {
                                                    setViewMediaCertificate({
                                                        open: true,
                                                        file: {
                                                            name: certificateData?.title,
                                                            description:
                                                                certificateData?.description,
                                                            files: certificateData?.fileLink,
                                                        },
                                                    })
                                                }}
                                            >
                                                <iframe
                                                    src={`${certificateData?.fileLink[0]}#view=fitH`}
                                                    title="PDF"
                                                    style={{
                                                        width: '100%',
                                                        height: '100%',
                                                        border: 'none',
                                                        cursor: 'pointer',
                                                    }}
                                                />
                                            </div>
                                        )
                                    ) : (
                                        <div className={tabStyles.logoBox}>
                                            <CertificatesLogoIcon />
                                        </div>
                                    )}
                                    <div className={tabStyles.itemBody}>
                                        <Row>
                                            <Space>
                                                {certificateData?.title && (
                                                    <Title
                                                        className={'titleSub'}
                                                    >
                                                        {certificateData?.title}
                                                    </Title>
                                                )}
                                                <Text className="titleLight">
                                                    {!certificateData?.isCompleted &&
                                                        `(Draft)`}
                                                </Text>
                                            </Space>
                                        </Row>
                                        <Space>
                                            {certificateData
                                                ?.certificateProvider?.name && (
                                                <Text
                                                    style={{
                                                        fontSize:
                                                            token.fontSize,
                                                    }}
                                                >
                                                    {
                                                        certificateData
                                                            ?.certificateProvider
                                                            ?.name
                                                    }
                                                </Text>
                                            )}
                                            {certificateData
                                                ?.certificateProvider?.name &&
                                                certificateData?.fieldOfStudy
                                                    ?.name &&
                                                '|'}
                                            {certificateData?.fieldOfStudy
                                                ?.name && (
                                                <Text
                                                    style={{
                                                        fontSize:
                                                            token.fontSize,
                                                    }}
                                                >
                                                    {
                                                        certificateData
                                                            ?.fieldOfStudy?.name
                                                    }
                                                </Text>
                                            )}
                                        </Space>
                                        <Text
                                            style={{
                                                fontSize: token.fontSizeLG,
                                            }}
                                            className={'titleLight'}
                                        >
                                            {startDate !== null &&
                                                startDate.toLocaleString(
                                                    'default',
                                                    {
                                                        year: 'numeric',
                                                        month: 'long',
                                                    }
                                                )}
                                        </Text>
                                        <Text
                                            style={{
                                                fontSize: token.fontSize,
                                            }}
                                        >
                                            {certificateData?.description}
                                        </Text>
                                    </div>
                                </div>
                            </div>
                        )
                    })}
            </div>
            <ModalProfile
                visibility={viewMediaCertificate?.open}
                handleCancel={() => {
                    setViewMediaCertificate({
                        open: false,
                        file: {},
                    })
                }}
                setMaxHeight={false}
                footer={false}
                icon={<CertificateIcon />}
                modalKey="viewVideo"
                modalTitle="Media"
                showTitle="Media"
                content={
                    <ViewMultiMediaModal
                        fileData={viewMediaCertificate?.file}
                    />
                }
            />
        </>
    )
}

export default CertificatesSummaryContent
